<template>
  <svg width="79" height="213" viewBox="0 0 79 213" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_1" clip-path="url(#clip0_2751_1718)">
      <g id="Group">
        <path
          id="Vector"
          d="M29.3317 0.964844L77.1995 41.8312C78.1772 42.6679 78.7271 43.8039 78.7271 44.986V212.965H66.3764V52.0324C66.3764 49.1386 65.0321 46.3676 62.6337 44.3182L20.5938 8.41812L29.3317 0.964844Z"
          fill="#9CD2EB"
        />
        <path
          id="Vector_2"
          d="M65.3219 42.023C68.4535 44.6942 70.1797 48.2481 70.1797 52.0323V212.965H74.9306V44.9859C74.9306 44.6635 74.7778 44.3564 74.5105 44.1262L26.7725 3.15234L22.9688 6.39156L65.3219 42.023Z"
          fill="#FFE7C0"
        />
      </g>
      <g id="Group_2">
        <path
          id="Vector_3"
          d="M8.26632 22.1973L49.5807 57.4679C50.4285 58.1894 50.902 59.172 50.902 60.1852V205.167H40.2469V66.2645C40.2469 63.7698 39.0859 61.3749 37.016 59.6095L0.727539 28.6297L8.26632 22.1973Z"
          fill="#9CD2EB"
        />
        <path
          id="Vector_4"
          d="M39.3302 57.6294C42.0341 59.9398 43.5235 63.0025 43.5235 66.2647V205.167H47.6252V60.1854C47.6252 59.9091 47.4953 59.6405 47.2662 59.4486L6.05879 24.0781L2.77441 26.8798L39.3302 57.6294Z"
          fill="#FFE7C0"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2751_1718">
        <rect width="78" height="212" fill="white" transform="translate(0.727539 0.964844)" />
      </clipPath>
    </defs>
  </svg>
</template>
